export default "__VITE_ASSET__Dou8qSfE__"